import { css } from 'astroturf';
import React from 'react';
import Link from '../../components/link';

const styles = css`
  .link {
    display: inline-block;
    margin-top: 2rem;
    box-shadow: none;
    background: none;
  }
`;

const IpadLink = () => (
  <Link to="https://apps.apple.com/us/app/polypane-go/id6740772640" className={styles.link}>
    <svg xmlns="http://www.w3.org/2000/svg" height="65px" viewBox="0 0 135 40" enableBackground="new 0 0 135 40">
      <g>
        <path
          fill="#FFFFFF"
          d="M134.032,35.268c0,2.116-1.714,3.83-3.834,3.83H4.729c-2.119,0-3.839-1.714-3.839-3.83V4.725
		c0-2.115,1.72-3.835,3.839-3.835h125.468c2.121,0,3.834,1.72,3.834,3.835L134.032,35.268L134.032,35.268z"
        />
        <path
          d="M134.032,35.268c0,2.116-1.714,3.83-3.834,3.83H4.729c-2.119,0-3.839-1.714-3.839-3.83V4.725
		c0-2.115,1.72-3.835,3.839-3.835h125.468c2.121,0,3.834,1.72,3.834,3.835L134.032,35.268L134.032,35.268z"
        />
        <path
          fill="#FFFFFF"
          d="M30.128,19.784c-0.029-3.223,2.639-4.791,2.761-4.864c-1.511-2.203-3.853-2.504-4.676-2.528
		c-1.967-0.207-3.875,1.177-4.877,1.177c-1.022,0-2.565-1.157-4.228-1.123c-2.14,0.033-4.142,1.272-5.24,3.196
		c-2.266,3.923-0.576,9.688,1.595,12.859c1.086,1.554,2.355,3.287,4.016,3.226c1.625-0.066,2.232-1.035,4.193-1.035
		c1.943,0,2.513,1.035,4.207,0.996c1.744-0.027,2.842-1.56,3.89-3.127c1.255-1.779,1.759-3.533,1.779-3.623
		C33.508,24.924,30.162,23.646,30.128,19.784z"
        />
        <path
          fill="#FFFFFF"
          d="M26.928,10.306c0.874-1.093,1.472-2.58,1.306-4.089c-1.265,0.056-2.847,0.875-3.758,1.944
		c-0.806,0.942-1.526,2.486-1.34,3.938C24.557,12.205,26.016,11.382,26.928,10.306z"
        />

        <g>
          <path
            fill="#FFFFFF"
            d="M53.665,31.504h-2.271l-1.244-3.909h-4.324l-1.185,3.909H42.43l4.285-13.308h2.646L53.665,31.504z
			 M49.775,25.955L48.65,22.48c-0.119-0.355-0.343-1.191-0.671-2.507h-0.04c-0.132,0.566-0.343,1.402-0.632,2.507l-1.106,3.475
			H49.775z"
          />
          <path
            fill="#FFFFFF"
            d="M64.663,26.588c0,1.632-0.443,2.922-1.33,3.869c-0.794,0.843-1.781,1.264-2.958,1.264
			c-1.271,0-2.185-0.453-2.74-1.361v5.035h-2.132V25.062c0-1.025-0.027-2.076-0.079-3.154h1.875l0.119,1.521h0.04
			c0.711-1.146,1.79-1.719,3.238-1.719c1.132,0,2.077,0.447,2.833,1.342C64.284,23.949,64.663,25.127,64.663,26.588z M62.491,26.666
			c0-0.934-0.21-1.704-0.632-2.311c-0.461-0.631-1.08-0.947-1.856-0.947c-0.526,0-1.004,0.176-1.431,0.523
			c-0.428,0.35-0.708,0.807-0.839,1.373c-0.066,0.264-0.099,0.479-0.099,0.649v1.601c0,0.697,0.214,1.286,0.642,1.768
			c0.428,0.48,0.984,0.721,1.668,0.721c0.803,0,1.428-0.311,1.875-0.928C62.267,28.496,62.491,27.68,62.491,26.666z"
          />
          <path
            fill="#FFFFFF"
            d="M75.7,26.588c0,1.632-0.443,2.922-1.33,3.869c-0.795,0.843-1.781,1.264-2.959,1.264
			c-1.271,0-2.185-0.453-2.74-1.361v5.035h-2.132V25.062c0-1.025-0.027-2.076-0.079-3.154h1.875l0.119,1.521h0.04
			c0.71-1.146,1.789-1.719,3.238-1.719c1.131,0,2.076,0.447,2.834,1.342C75.32,23.949,75.7,25.127,75.7,26.588z M73.527,26.666
			c0-0.934-0.211-1.704-0.633-2.311c-0.461-0.631-1.078-0.947-1.854-0.947c-0.526,0-1.004,0.176-1.433,0.523
			c-0.428,0.35-0.707,0.807-0.838,1.373c-0.065,0.264-0.1,0.479-0.1,0.649v1.601c0,0.697,0.215,1.286,0.641,1.768
			c0.428,0.479,0.984,0.721,1.67,0.721c0.804,0,1.429-0.311,1.875-0.928C73.303,28.496,73.527,27.68,73.527,26.666z"
          />
          <path
            fill="#FFFFFF"
            d="M88.04,27.771c0,1.133-0.396,2.054-1.183,2.765c-0.866,0.776-2.075,1.165-3.625,1.165
			c-1.432,0-2.58-0.276-3.446-0.829l0.493-1.777c0.935,0.554,1.962,0.83,3.08,0.83c0.804,0,1.429-0.182,1.875-0.543
			c0.447-0.362,0.673-0.846,0.673-1.45c0-0.541-0.187-0.994-0.554-1.363c-0.369-0.368-0.979-0.711-1.836-1.026
			c-2.33-0.869-3.496-2.14-3.496-3.812c0-1.092,0.412-1.986,1.234-2.685c0.822-0.698,1.912-1.047,3.268-1.047
			c1.211,0,2.22,0.211,3.021,0.632l-0.535,1.738c-0.754-0.408-1.605-0.612-2.557-0.612c-0.752,0-1.342,0.185-1.764,0.553
			c-0.355,0.329-0.535,0.73-0.535,1.206c0,0.525,0.205,0.961,0.613,1.303c0.354,0.315,1,0.658,1.934,1.026
			c1.146,0.462,1.988,1,2.527,1.618C87.77,26.081,88.04,26.852,88.04,27.771z"
          />
          <path
            fill="#FFFFFF"
            d="M95.107,23.508h-2.35v4.659c0,1.185,0.414,1.776,1.244,1.776c0.381,0,0.697-0.032,0.947-0.099l0.059,1.619
			c-0.42,0.157-0.973,0.236-1.658,0.236c-0.842,0-1.5-0.257-1.975-0.771c-0.473-0.514-0.711-1.375-0.711-2.587v-4.837h-1.4v-1.6h1.4
			v-1.757l2.094-0.632v2.389h2.35V23.508z"
          />
          <path
            fill="#FFFFFF"
            d="M105.689,26.627c0,1.475-0.422,2.686-1.264,3.633c-0.881,0.975-2.053,1.461-3.514,1.461
			c-1.41,0-2.531-0.467-3.367-1.4c-0.836-0.935-1.254-2.113-1.254-3.534c0-1.487,0.432-2.705,1.293-3.652
			c0.863-0.948,2.025-1.422,3.486-1.422c1.408,0,2.539,0.468,3.395,1.402C105.282,24.021,105.689,25.191,105.689,26.627z
			 M103.479,26.676c0-0.879-0.19-1.633-0.571-2.264c-0.447-0.762-1.087-1.143-1.916-1.143c-0.854,0-1.509,0.381-1.955,1.143
			c-0.382,0.631-0.572,1.398-0.572,2.304c0,0.88,0.19,1.636,0.572,2.265c0.461,0.762,1.104,1.143,1.937,1.143
			c0.815,0,1.454-0.389,1.916-1.162C103.282,28.316,103.479,27.557,103.479,26.676z"
          />
          <path
            fill="#FFFFFF"
            d="M112.622,23.783c-0.211-0.039-0.437-0.059-0.672-0.059c-0.75,0-1.33,0.282-1.738,0.85
			c-0.354,0.5-0.532,1.132-0.532,1.895v5.035h-2.132V24.93c0-1.105-0.021-2.113-0.062-3.021h1.857l0.078,1.836h0.059
			c0.226-0.631,0.58-1.14,1.066-1.521c0.475-0.343,0.988-0.514,1.541-0.514c0.197,0,0.375,0.014,0.533,0.039L112.622,23.783
			L112.622,23.783z"
          />
          <path
            fill="#FFFFFF"
            d="M122.157,26.252c0,0.382-0.025,0.704-0.078,0.967h-6.396c0.024,0.948,0.334,1.674,0.928,2.174
			c0.539,0.446,1.236,0.67,2.092,0.67c0.947,0,1.811-0.15,2.588-0.453l0.334,1.479c-0.908,0.396-1.98,0.593-3.217,0.593
			c-1.488,0-2.656-0.438-3.506-1.312c-0.848-0.875-1.273-2.051-1.273-3.524c0-1.446,0.395-2.651,1.186-3.612
			c0.828-1.026,1.947-1.539,3.355-1.539c1.383,0,2.43,0.513,3.141,1.539C121.874,24.047,122.157,25.055,122.157,26.252z
			 M120.124,25.699c0.015-0.633-0.125-1.178-0.414-1.639c-0.369-0.594-0.937-0.89-1.698-0.89c-0.697,0-1.265,0.289-1.697,0.869
			c-0.355,0.461-0.566,1.015-0.631,1.658L120.124,25.699L120.124,25.699z"
          />
        </g>
        <g>
          <path
            fill="#FFFFFF"
            d="M48.747,13.433H47.63l-0.611-1.921h-2.125l-0.583,1.921h-1.087l2.106-6.541h1.3L48.747,13.433z
			 M46.835,10.706l-0.553-1.708c-0.058-0.175-0.165-0.582-0.33-1.232h-0.02c-0.068,0.281-0.165,0.689-0.311,1.232l-0.543,1.708
			H46.835z"
          />
          <path
            fill="#FFFFFF"
            d="M54.013,8.717l-1.786,4.716h-1.019L49.48,8.717h1.126l0.806,2.494c0.136,0.417,0.252,0.815,0.339,1.193
			h0.029c0.078-0.339,0.194-0.737,0.339-1.193l0.796-2.494H54.013z"
          />
          <path
            fill="#FFFFFF"
            d="M57.815,13.433l-0.078-0.543h-0.029c-0.32,0.437-0.786,0.65-1.378,0.65c-0.844,0-1.446-0.592-1.446-1.388
			c0-1.164,1.009-1.766,2.756-1.766v-0.087c0-0.621-0.33-0.932-0.98-0.932c-0.466,0-0.874,0.117-1.232,0.35l-0.213-0.689
			c0.437-0.272,0.98-0.408,1.621-0.408c1.232,0,1.854,0.65,1.854,1.951v1.737c0,0.476,0.02,0.845,0.068,1.126L57.815,13.433
			L57.815,13.433z M57.669,11.084c-1.165,0-1.747,0.282-1.747,0.951c0,0.495,0.301,0.737,0.718,0.737
			c0.534,0,1.029-0.407,1.029-0.96V11.084z"
          />
          <path
            fill="#FFFFFF"
            d="M61.024,7.94c-0.349,0-0.621-0.272-0.621-0.631s0.281-0.621,0.641-0.621c0.359,0,0.65,0.262,0.64,0.621
			C61.684,7.688,61.413,7.94,61.024,7.94z M61.568,13.433H60.52V8.717h1.048V13.433z"
          />
          <path fill="#FFFFFF" d="M64.478,13.433H63.43v-6.88h1.048V13.433z" />
          <path
            fill="#FFFFFF"
            d="M68.932,13.433l-0.078-0.543h-0.029c-0.32,0.437-0.786,0.65-1.378,0.65c-0.844,0-1.446-0.592-1.446-1.388
			c0-1.164,1.009-1.766,2.756-1.766v-0.087c0-0.621-0.33-0.932-0.98-0.932c-0.466,0-0.874,0.117-1.232,0.35l-0.214-0.69
			c0.437-0.272,0.98-0.408,1.621-0.408c1.232,0,1.854,0.65,1.854,1.951v1.737c0,0.476,0.021,0.845,0.067,1.126H68.932z
			 M68.786,11.084c-1.165,0-1.747,0.282-1.747,0.951c0,0.495,0.301,0.737,0.718,0.737c0.534,0,1.029-0.407,1.029-0.96V11.084z"
          />
          <path
            fill="#FFFFFF"
            d="M74.052,13.54c-0.669,0-1.163-0.282-1.483-0.835h-0.021l-0.06,0.728h-0.893
			c0.029-0.378,0.039-0.806,0.039-1.271V6.553h1.049v2.854h0.02c0.311-0.524,0.814-0.786,1.504-0.786
			c1.136,0,1.932,0.971,1.932,2.387C76.139,12.472,75.255,13.54,74.052,13.54z M73.839,9.444c-0.603,0-1.155,0.524-1.155,1.252
			v0.825c0,0.65,0.496,1.184,1.137,1.184c0.785,0,1.252-0.64,1.252-1.659C75.072,10.095,74.586,9.444,73.839,9.444z"
          />
          <path fill="#FFFFFF" d="M78.736,13.433h-1.047v-6.88h1.047V13.433z" />
          <path
            fill="#FFFFFF"
            d="M84.441,11.327h-3.146c0.021,0.893,0.611,1.397,1.485,1.397c0.466,0,0.893-0.078,1.271-0.223l0.163,0.728
			c-0.446,0.194-0.97,0.291-1.581,0.291c-1.476,0-2.349-0.932-2.349-2.377c0-1.446,0.894-2.533,2.231-2.533
			c1.203,0,1.961,0.893,1.961,2.242C84.48,11.036,84.471,11.201,84.441,11.327z M83.48,10.58c0-0.728-0.369-1.242-1.039-1.242
			c-0.602,0-1.076,0.524-1.146,1.242H83.48z"
          />
          <path
            fill="#FFFFFF"
            d="M90.793,13.54c-1.378,0-2.271-1.029-2.271-2.426c0-1.456,0.912-2.494,2.35-2.494
			c1.357,0,2.271,0.98,2.271,2.417C93.143,12.511,92.201,13.54,90.793,13.54z M90.833,9.386c-0.757,0-1.242,0.708-1.242,1.698
			c0,0.971,0.495,1.679,1.232,1.679s1.231-0.757,1.231-1.699C92.055,10.104,91.57,9.386,90.833,9.386z"
          />
          <path
            fill="#FFFFFF"
            d="M98.777,13.433H97.73v-2.708c0-0.834-0.32-1.252-0.951-1.252c-0.621,0-1.049,0.534-1.049,1.155v2.805
			h-1.047v-3.368c0-0.417-0.011-0.864-0.039-1.349h0.922l0.049,0.728h0.029c0.28-0.504,0.854-0.825,1.494-0.825
			c0.989,0,1.639,0.757,1.639,1.989V13.433L98.777,13.433z"
          />
          <path
            fill="#FFFFFF"
            d="M105.634,9.503h-1.153v2.29c0,0.583,0.203,0.874,0.61,0.874c0.185,0,0.341-0.02,0.466-0.049l0.029,0.796
			c-0.204,0.078-0.477,0.117-0.814,0.117c-0.826,0-1.319-0.456-1.319-1.65V9.503h-0.688V8.717h0.688V7.853l1.028-0.311v1.174h1.153
			V9.503z"
          />
          <path
            fill="#FFFFFF"
            d="M111.184,13.433h-1.049v-2.688c0-0.844-0.32-1.271-0.951-1.271c-0.543,0-1.047,0.369-1.047,1.116v2.843
			h-1.049v-6.88h1.049v2.833h0.02c0.33-0.514,0.806-0.767,1.417-0.767c0.999,0,1.61,0.776,1.61,2.009V13.433z"
          />
          <path
            fill="#FFFFFF"
            d="M116.539,11.327h-3.145c0.02,0.893,0.61,1.397,1.484,1.397c0.467,0,0.893-0.078,1.271-0.223l0.164,0.728
			c-0.446,0.194-0.971,0.291-1.582,0.291c-1.476,0-2.349-0.932-2.349-2.377c0-1.446,0.894-2.533,2.231-2.533
			c1.203,0,1.961,0.893,1.961,2.242C116.578,11.036,116.568,11.201,116.539,11.327z M115.578,10.58c0-0.728-0.368-1.242-1.038-1.242
			c-0.603,0-1.077,0.524-1.146,1.242H115.578z"
          />
        </g>
      </g>
    </svg>
  </Link>
);

export default IpadLink;
